/* eslint-disable react/jsx-key */
import React from 'react';
import styled from 'styled-components';

const ScaleContainer = styled.div`
  width: fit-content;
`;

const ScaleWrapper = styled.div`
  display: flex;
`;

const LabelContainer = styled.div`
  display: flex;
  margin-bottom: 4px;
`;

const ScaleLabel = styled.span`
  &:first-child {
    flex: 1;
  }

  font-weight: normal;
  font-size: 8px;
  line-height: 8px;
  color: var(--secondary-gray-dark);
`;

const ScalePoint = styled.div`
  background-color: ${({ bgColor }) => bgColor && bgColor};
  width: 12px;
  height: 4px;
  margin-right: 2px;
`;

const HeatScale = ({ colorScale }) => (
  <ScaleContainer>
    <LabelContainer>
      <ScaleLabel>Atrasado</ScaleLabel>
      <ScaleLabel>No prazo</ScaleLabel>
    </LabelContainer>
    <ScaleWrapper>
      {Object.values(colorScale).map(color => (
        <ScalePoint bgColor={color} />
      ))}
    </ScaleWrapper>
  </ScaleContainer>
);

export default HeatScale;
